module.exports = __webpack_public_path__ + "static/media/marcia_pena.e89cc94b.jpg";